import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import InfoTooltip from '../InfoTooltip';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import {
  createCategory,
  createCleaner,
  createDoorList,
  createSpecialAccesss,
  getBnbList,
  uploadFile,
} from '../../helper/backend_helper';

const AddCleaner = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ profileImage: null });
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [bnb, setBnB] = useState([]);
  const [cleaningCities, setCleaningCities] = useState([]);

  const [cleaningCost, setCleaningCost] = useState(0);
  const [bedSheetCost, setBedSheetCost] = useState(0);

  const [isChecked, setIsChecked] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [isChecked3, setIsChecked3] = useState(false);
  const [isChecked4, setIsChecked4] = useState(false);
  const [checkoutOnlyFakeArrivals, setCheckoutOnlyFakeArrivals] = useState(false);
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const handleCheckboxChange2 = (event) => {
    setIsChecked2(event.target.checked);
  };

  const handleCheckboxChange3 = (event) => {
    setIsChecked3(event.target.checked);
  };

  const handleCheckboxChange4 = (event) => {
    setIsChecked4(event.target.checked);
  };

  const [loading, setLoading] = useState(false);
  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const [users, setUsers] = useState([]);
  console.log('users', users);
  async function fetchData() {
    try {
      const usersResponse = await getBnbList();
      setUsers(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.BnBShortName?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.BnBShortName?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);

      if (!name) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Name is required',
        });
        setLoading(false);
        return;
      }

      if (!phoneNumber) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'phone no is required',
        });
        setLoading(false);
        return;
      }

      if (bnb.length === 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'BnB Name is required',
        });
        setLoading(false);
        return;
      }

      // Prepare headers for multipart form data

      const Categorydata = {
        name,
        bnb,
        cleaningCities,
        phoneNumber,
        cleaningCost,
        bedSheetCost,
        accessDoors: isChecked,
        isMandatory: isChecked2,
        maintance: isChecked3,
        emergencyKeys: isChecked4,
        checkoutOnlyFakeArrivals,
        type: 'regularCleaner',
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createCleaner(Categorydata, Categoryheaders);

      Swal.fire({
        icon: 'success',
        title: 'Cleaner created successfully',
      });
      setName('');
      setBnB([]);
      setPhoneNumber('');

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  const allBnBNames = useMemo(
    () =>
      users
        .map((u) => u?.BnBShortName)
        .filter(Boolean)
        .sort(),
    [users]
  );
  const cityOptions = useMemo(
    () => Array.from(new Set(users.map((u) => u?.city).filter(Boolean))).sort(),
    [users]
  );
  const cityBnBNames = useMemo(() => {
    const grouped = {};
    users.forEach((user) => {
      if (!user?.city || !user?.BnBShortName) return;
      grouped[user.city] = [...(grouped[user.city] || []), user.BnBShortName];
    });
    return grouped;
  }, [users]);
  const updateCleaningCities = (selectedCities) => {
    const nextCities = typeof selectedCities === 'string' ? selectedCities.split(',') : selectedCities;
    const previousCityBnbs = cleaningCities.flatMap((city) => cityBnBNames[city] || []);
    const nextCityBnbs = nextCities.flatMap((city) => cityBnBNames[city] || []);

    // City cleaning is stored separately for future BnBs, while current BnBs are expanded into the regular list.
    setCleaningCities(nextCities);
    setBnB((currentBnbs) =>
      Array.from(new Set([...currentBnbs.filter((name) => !previousCityBnbs.includes(name)), ...nextCityBnbs])).sort()
    );
  };
  const SELECT_ALL_VALUE = '__select_all__';

  return (
    <>
      <Helmet>
        <title> Add Cleaner </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Add Cleaner</Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: { xs: '100%', sm: '50ch' } }, // Responsive
          }}
          noValidate
          autoComplete="off"
        >
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Name <InfoTooltip title="The cleaner's full name, shown on their schedule and in reports." /></FormLabel>
              <TextField
                label="Enter Name"
                id="outlined-size-small"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Phone Number <InfoTooltip title="WhatsApp number where this cleaner receives their daily schedule and alerts. Include the country code, e.g. +39…" /></FormLabel>
              <TextField
                type="text"
                label="Enter Phone Number"
                id="outlined-size-small"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack spacing={{ xs: 2, sm: 4 }} mt={2} direction="row" useFlexGap flexWrap="wrap">
            <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
              <FormLabel sx={{ mb: 1 }}>Cleaning by city <InfoTooltip title="Auto-assigns every BnB in the chosen city to this cleaner, including BnBs added to that city later." /></FormLabel>
              <Select
                multiple
                value={cleaningCities}
                renderValue={(selected) => selected.join(', ')}
                onChange={(event) => updateCleaningCities(event.target.value)}
              >
                {cityOptions.map((city) => (
                  <MenuItem key={city} value={city}>
                    <Checkbox checked={cleaningCities.indexOf(city) > -1} />
                    {city}
                  </MenuItem>
                ))}
              </Select>
              <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
                Selecting a city adds all current BnBs in that city and keeps future BnBs in that city assigned automatically.
              </Typography>
            </FormControl>
          </Stack>

          <Stack spacing={{ xs: 2, sm: 4 }} mt={2} direction="row" useFlexGap flexWrap="wrap">
            {/* <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
              <FormLabel sx={{ mb: 1 }}>BnB</FormLabel>
              <Select
                labelId="demo-multi-select-label"
                id="demo-multi-select"
                multiple
                value={bnb} // This will be an array
                onChange={(e) => setBnB(e.target.value)}
                renderValue={(selected) => selected.join(', ')} // Render selected values as a comma-separated string
              >
                {users?.map((user) => (
                  <MenuItem key={user._id} value={user.BnBShortName}>
                    <Checkbox checked={bnb.indexOf(user.BnBShortName) > -1} />
                    {user.BnBShortName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
            <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
              <FormLabel sx={{ mb: 1 }}>BnB <InfoTooltip title="The specific properties this cleaner is responsible for — their schedule is built from bookings at these BnBs." /></FormLabel>
              <Select
                multiple
                value={bnb}
                renderValue={(selected) => selected.join(', ')}
                onChange={(event) => {
                  const raw = event.target.value;
                  const value = typeof raw === 'string' ? raw.split(',') : raw;

                  if (value.includes(SELECT_ALL_VALUE)) {
                    // Toggle: if all already selected -> clear; else select all
                    if (bnb.length === allBnBNames.length) {
                      setBnB([]);
                    } else {
                      setBnB(allBnBNames);
                    }
                  } else {
                    setBnB(value);
                  }
                }}
              >
                <MenuItem value={SELECT_ALL_VALUE}>
                  <Checkbox
                    checked={bnb.length === allBnBNames.length && allBnBNames.length > 0}
                    indeterminate={bnb.length > 0 && bnb.length < allBnBNames.length}
                  />
                  <Typography fontWeight="bold" color="primary">
                    {bnb.length === allBnBNames.length ? 'Deselect All' : 'Select All'}
                  </Typography>
                </MenuItem>
                <Box sx={{ borderBottom: '1px solid #e0e0e0', mx: 1, my: 0.5 }} />
                {allBnBNames.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={bnb.indexOf(name) > -1} />
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack spacing={{ xs: 2, sm: 4 }} mt={4} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Default Cleaning Cost <InfoTooltip title="Standard amount paid to this cleaner per cleaning (€). Used in cleaning reports and statements." /></FormLabel>
              <TextField
                multiline
                label="Enter Cost"
                id="outlined-size-small"
                value={cleaningCost}
                onChange={(e) => setCleaningCost(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack spacing={{ xs: 2, sm: 4 }} mt={4} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Default BedSheet Cost <InfoTooltip title="Standard charge for a bed-linen change per cleaning (€)." /></FormLabel>
              <TextField
                multiline
                label="Enter Cost"
                id="outlined-size-small"
                value={bedSheetCost}
                onChange={(e) => setBedSheetCost(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack sx={{ marginTop: 2, display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Typography variant="h6" mt={1}>
              Doors Access: <InfoTooltip title="Lets this cleaner open the property's smart doors from the cleaner app." />
            </Typography>
            <Checkbox checked={isChecked} onChange={handleCheckboxChange} />
          </Stack>

          <Stack sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Typography variant="h6" mt={1}>
              Mandatory Report: <InfoTooltip title="Requires this cleaner to submit a cleaning report after each job." />
            </Typography>
            <Checkbox checked={isChecked2} onChange={handleCheckboxChange2} />
          </Stack>
          <Stack sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Typography variant="h6" mt={1}>
              Maintenance: <InfoTooltip title="Lets this cleaner receive and handle maintenance requests for their properties." />
            </Typography>
            <Checkbox checked={isChecked3} onChange={handleCheckboxChange3} />
          </Stack>
          <Stack sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            <Typography variant="h6" mt={1}>
              Emergency Keys: <InfoTooltip title="Grants this cleaner access to emergency key boxes." />
            </Typography>
            <Checkbox checked={isChecked4} onChange={handleCheckboxChange4} />
          </Stack>
          <Stack sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}>
            <Typography variant="h6" mt={1}>
              Only check-in for checkouts: <InfoTooltip title="On same-day checkout→arrival turnovers, only notify this cleaner for the check-in side." />
            </Typography>
            <Checkbox
              checked={checkoutOnlyFakeArrivals}
              onChange={(event) => setCheckoutOnlyFakeArrivals(event.target.checked)}
            />
            <Typography variant="body2" color="text.secondary" mt={1}>
              Show the next guest arrival on checkout day when there is no real same-day arrival.
            </Typography>
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Save
        </LoadingButton>
      </Card>
    </>
  );
};

export default AddCleaner;
